import { Dialog as D } from "radix-ui";

export function Dialog({ open, onOpenChange, title, description, children, footer }: {
  open: boolean; onOpenChange: (v: boolean) => void; title: string; description?: React.ReactNode; children?: React.ReactNode; footer: React.ReactNode;
}) {
  return (
    <D.Root open={open} onOpenChange={onOpenChange}>
      <D.Portal>
        <D.Overlay className="overlay" />
        <D.Content className="dialog">
          <div className="dialog-head">
            <D.Title asChild><h2>{title}</h2></D.Title>
            {description ? <D.Description asChild><p>{description}</p></D.Description> : <D.Description className="sr-only">{title}</D.Description>}
          </div>
          {children && <div className="dialog-body">{children}</div>}
          <div className="dialog-foot">{footer}</div>
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}
